module.exports = __webpack_public_path__ + "static/img/GB.ee2043cd.jpg";